/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2025 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { contentText, titleText } from "@monsma/App/WidgetExtensions/OrderDetails/OrderDateExtension";
import React from "react";
import { useContext } from "react";

export interface OrderCreatedByStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    createdByText?: TypographyProps;
}

const createdByStyles: OrderCreatedByStyles = {
    titleText,
    createdByText: contentText,
};

const OrderCreatedBy = () => {
    const { value } = useContext(OrderStateContext);
    const createdBy = value?.properties?.createdBy;

    if (!createdBy) {
        return null;
    }
    return (
        <StyledWrapper {...createdByStyles.wrapper}>
            <Typography {...createdByStyles.titleText}>{translate("Created By")}</Typography>
            <Typography {...createdByStyles.createdByText}>{createdBy}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderCreatedBy,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
